module.exports = __webpack_public_path__ + "assets/verified.80a3532e.svg";